import API from "../../Common/API";

export const POLLS_API_URL = `${API.getBaseUrl()}polls/`;
